var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('calendarComponent',{class:{calendars: _vm.componentConfig.calendarType == '1', calendarmapp: !_vm.isH5, calendarmh5: _vm.isH5 },attrs:{"platform":_vm.platform,"sensors":_vm.sensors,"componentConfig":_vm.componentConfig}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }